import {
  CourseFilterOptionsResponse,
  CourseResponse,
  GetCoursesParams,
  LearningCoursesResponse,
  RecommendedCoursesResponse,
} from "../types/api";
import axiosInstance from "../utils/axios";

export const getCourses = async (
  credentials: GetCoursesParams
): Promise<CourseResponse> => {
  try {
    const params: Record<string, string | boolean> = {};

    if (credentials.platform?.length) {
      params["platform"] = credentials.platform.join(",");
    }

    if (credentials.language?.length) {
      params["language"] = credentials.language.join(",");
    }
    if (credentials.is_active) params["is_active"] = credentials.is_active;
    if (credentials.created_after)
      params["created_after"] = credentials.created_after;
    if (credentials.search) params["search"] = credentials.search;
    if (credentials.ordering) params["ordering"] = credentials.ordering;
    if (credentials.page) params["page"] = credentials.page.toString();
    if (credentials.rating_min)
      params["rating_min"] = credentials.rating_min.toString();
    if (credentials.rating_max)
      params["rating_max"] = credentials.rating_max.toString();
    if (credentials.price_min)
      params["price_min"] = credentials.price_min.toString();
    if (credentials.price_max)
      params["price_max"] = credentials.price_max.toString();
    if (credentials.organization)
      params["organization"] = credentials.organization;
    if (credentials.is_free !== undefined) {
      params["is_free"] = credentials.is_free;
    }
    if (credentials.category) params["category"] = credentials.category;
    if (credentials.topic) params["topic"] = credentials.topic;

    const response = await axiosInstance.get("api/courses/courses/", {
      params,
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching courses:", error);
    throw new Error("Failed to fetch courses");
  }
};

export const getRecommendedCourses = async (
  credentials: GetCoursesParams = {}
): Promise<RecommendedCoursesResponse> => {
  try {
    const params: Record<string, string | boolean> = {};

    if (credentials.platform?.length) {
      params["platform"] = credentials.platform.join(",");
    }

    if (credentials.language?.length) {
      params["language"] = credentials.language.join(",");
    }

    if (credentials.is_active) params["is_active"] = credentials.is_active;
    if (credentials.created_after)
      params["created_after"] = credentials.created_after;
    if (credentials.search) params["search"] = credentials.search;
    if (credentials.ordering) params["ordering"] = credentials.ordering;
    if (credentials.page) params["page"] = credentials.page.toString();
    if (credentials.rating_min)
      params["rating_min"] = credentials.rating_min.toString();
    if (credentials.rating_max)
      params["rating_max"] = credentials.rating_max.toString();
    if (credentials.price_min)
      params["price_min"] = credentials.price_min.toString();
    if (credentials.price_max)
      params["price_max"] = credentials.price_max.toString();
    if (credentials.organization)
      params["organization"] = credentials.organization;
    if (credentials.is_free !== undefined) {
      params["is_free"] = credentials.is_free;
    }
    if (credentials.category) params["category"] = credentials.category;
    if (credentials.topic) params["topic"] = credentials.topic;

    const response = await axiosInstance.get("api/courses/recommendations/", {
      params,
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching courses:", error);
    throw new Error("Failed to fetch courses");
  }
};

export const getLearningCourses = async (
  credentials: GetCoursesParams = {}
): Promise<LearningCoursesResponse> => {
  try {
    const params: Record<string, string | boolean> = {};

    if (credentials.platform?.length) {
      params["platform"] = credentials.platform.join(",");
    }

    if (credentials.language?.length) {
      params["language"] = credentials.language.join(",");
    }

    if (credentials.is_active) params["is_active"] = credentials.is_active;
    if (credentials.created_after)
      params["created_after"] = credentials.created_after;
    if (credentials.search) params["search"] = credentials.search;
    if (credentials.ordering) params["ordering"] = credentials.ordering;
    if (credentials.page) params["page"] = credentials.page.toString();
    if (credentials.rating_min)
      params["rating_min"] = credentials.rating_min.toString();
    if (credentials.rating_max)
      params["rating_max"] = credentials.rating_max.toString();
    if (credentials.price_min)
      params["price_min"] = credentials.price_min.toString();
    if (credentials.price_max)
      params["price_max"] = credentials.price_max.toString();
    if (credentials.organization)
      params["organization"] = credentials.organization;
    if (credentials.is_free !== undefined) {
      params["is_free"] = credentials.is_free;
    }
    if (credentials.category) params["category"] = credentials.category;
    if (credentials.topic) params["topic"] = credentials.topic;
    if (credentials.status) params["status"] = credentials.status;

    const response = await axiosInstance.get("api/courses/learning-courses/", {
      params,
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching courses:", error);
    throw new Error("Failed to fetch courses");
  }
};

export const addLearningCourse = async ({ courseId }: { courseId: number }) => {
  try {
    const response = await axiosInstance.post("api/courses/learning-courses/", {
      course: courseId,
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching courses:", error);
    throw new Error("Failed to fetch courses");
  }
};

export const removeLearningCourse = async ({
  courseId,
}: {
  courseId: number;
}) => {
  try {
    await axiosInstance.delete(`api/courses/learning-courses/${courseId}/`);

    return true;
  } catch (error) {
    console.error("Error fetching courses:", error);
    throw new Error("Failed to fetch courses");
  }
};

export const changeCourseStatus = async ({
  courseId,
  status,
}: {
  courseId: number;
  status: string;
}) => {
  try {
    const response = await axiosInstance.patch(
      `api/courses/learning-courses/${courseId}/`,
      {
        status: status,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching courses:", error);
    throw new Error("Failed to fetch courses");
  }
};

export const getCoursesFilterOptions = async () => {
  try {
    const response = await axiosInstance.get<CourseFilterOptionsResponse>(
      "api/courses/filter-options/"
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching courses:", error);
    throw new Error("Failed to fetch courses");
  }
};
